import React from "react";
import { Container } from "@material-ui/core";
import SubmitServiceCallForm from "./SubmitServiceCallForm";
import ImgHeader from "../ImgHeader";
import BlockQuote from "../BlockQuote";
import { H1, H2 } from "../Headers";
import styled from "styled-components";

const Wrapper = styled(Container)`
  padding: 2em;
  margin: 0;
  max-width: 1200px;
`;

export default function SubmitServiceRequest() {
  return (
    <>
      <ImgHeader url="/static/img/Card-ServiceRequest.png" shadowOpacity={0.3}>
        <H1>Submit A Service Request</H1>
      </ImgHeader>
      <Wrapper>
        <Container>
          <H2>Get help from the professionals</H2>
          <BlockQuote>
            Need a Skyward development sandbox? Seeking consulting or extra training on Skyward products? Need other techincal assistance? Pick a service from
            the list below and fill out the details to get the ball rolling!
          </BlockQuote>
          <SubmitServiceCallForm isServiceRequest={true} />
        </Container>
      </Wrapper>
    </>
  );
}
